export const APPLE_STORE_APP_ID = '1455336523';
export const APPLE_STORE_LINK = `https://apps.apple.com/us/app/bumpy-international-dating/id${APPLE_STORE_APP_ID}?platform=iphone`;
export const GOOGLE_STORE_LINK =
  'https://play.google.com/store/apps/details?id=app.bumpy.android&pli=1';
export const SUPPORT_EMAIL = 'support@bumpy.app';
